import React, { useState, useMemo } from 'react';
import styles from '../../styles/AdminPanel.module.scss';
import { assetUrl } from '../../utils/imageUrl';

const ProductSelectModal = ({
  products,
  categories = [],
  isOpen,
  onClose,
  onSelect,
  variant = 'default',
  excludeProductId = null,
  excludeIds = [],
  title = 'Оберіть товар',
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');

  const filteredProducts = useMemo(() => {
    const excluded = new Set(
      [
        excludeProductId,
        ...excludeIds,
      ]
        .filter((id) => id !== null && id !== undefined && id !== '')
        .map((id) => Number(id))
    );

    const query = searchQuery.trim().toLowerCase();

    return (products || [])
      .filter((product) => !excluded.has(Number(product.id)))
      .filter((product) => {
        if (categoryFilter !== 'all' && Number(product.category?.id) !== Number(categoryFilter)) {
          return false;
        }
        if (!query) return true;
        const titleText = (product.title || '').toLowerCase();
        const article = (product.article || '').toLowerCase();
        const category = (product.category?.name || '').toLowerCase();
        return titleText.includes(query) || article.includes(query) || category.includes(query);
      });
  }, [products, searchQuery, categoryFilter, excludeProductId, excludeIds]);

  const handleClose = () => {
    setSearchQuery('');
    setCategoryFilter('all');
    onClose();
  };

  const handleSelectProduct = (product) => {
    onSelect(product);
    setSearchQuery('');
    setCategoryFilter('all');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div className={styles.productSelectModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{title}</h3>
          <button 
            className={styles.modalCloseButton}
            onClick={handleClose}
            type="button"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className={styles.modalSearch}>
          {categories.length > 0 && (
            <select
              className={styles.modalCategorySelect}
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="all">Усі категорії</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          )}
          <div className={styles.searchInputWrapper}>
            <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Пошук за назвою, артикулом або категорією..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>
        </div>

        <div className={styles.modalContent}>
          {filteredProducts.length === 0 ? (
            <div className={styles.emptyProducts}>
              <p>{searchQuery || categoryFilter !== 'all' ? 'Товари не знайдено' : 'Немає доступних товарів'}</p>
            </div>
          ) : (
            <div className={`${styles.productsList} ${variant === 'related' ? styles.productsListVertical : ''}`}>
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className={styles.productCard}
                  onClick={() => handleSelectProduct(product)}
                >
                  <div className={styles.productImage}>
                    {product.images && product.images.length > 0 ? (
                      <img
                        src={assetUrl(product.images[0])}
                        alt={product.title}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <div className={styles.noImage}>Немає фото</div>
                    )}
                  </div>
                  <div className={styles.productInfo}>
                    <h4 className={styles.productTitle}>{product.title}</h4>
                    <div className={styles.productDetails}>
                      <span className={styles.productCategory}>
                        {product.category?.name || 'Без категорії'}
                      </span>
                      {product.article && (
                        <span className={styles.productArticle}>
                          Арт: {product.article}
                        </span>
                      )}
                    </div>
                    <div className={styles.productPrice}>
                      {variant === 'gift' ? (
                        <span className={styles.giftBadge}>Подарунок</span>
                      ) : (
                        `${product.price}₴`
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    className={styles.selectButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectProduct(product);
                    }}
                  >
                    Обрати
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductSelectModal;

